import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { ref, watch } from 'vue'
import { Id, MunicipalEntitiesService, SalesPointsService } from '@prodcard/core'
import { VSalesPointsSelect, VMunicipalEntitiesSelect, VDateFieldV2 } from '../../../../components'

export interface SearchParams {
  dateFrom?: Date
  dateTo?: Date
  salesPointId?: Id
  municipalEntityId?: Id
}

interface Props {
  salesPointsService: SalesPointsService
  municipalEntitiesService: MunicipalEntitiesService
  defaultSearchParams: SearchParams
  loading?: boolean
  readonlyMe?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FilterBox',
  props: {
    salesPointsService: {},
    municipalEntitiesService: {},
    defaultSearchParams: {},
    loading: { type: Boolean, default: false },
    readonlyMe: { type: Boolean, default: false }
  },
  emits: ['update'],
  setup(__props: any, { emit }) {

const props = __props;




const searchParams = ref({
  dateFrom: props.defaultSearchParams.dateFrom,
  dateTo: props.defaultSearchParams.dateTo,
  salesPointId: props.defaultSearchParams.salesPointId,
  municipalEntityId: props.defaultSearchParams.municipalEntityId,
})

const update = (e: Event, reset?: boolean) => {
  if (reset) {
    Object.assign(searchParams.value, {
      dateFrom: undefined,
      dateTo: undefined,
      salesPointId: undefined,
      municipalEntityId: props.readonlyMe ? searchParams.value.municipalEntityId : undefined,
    })
  }
  emit('update', searchParams.value)
}

watch(
  () => searchParams.value.municipalEntityId,
  () => {
    searchParams.value.salesPointId = undefined
  },
)

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              (!_ctx.readonlyMe)
                ? (_openBlock(), _createBlock(_component_v_col, {
                    key: 0,
                    cols: "6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(VMunicipalEntitiesSelect), {
                        modelValue: searchParams.value.municipalEntityId,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchParams.value.municipalEntityId) = $event)),
                        "municipal-entities-service": _ctx.municipalEntitiesService,
                        readonly: _ctx.readonlyMe,
                        density: "comfortable"
                      }, null, 8, ["modelValue", "municipal-entities-service", "readonly"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_col, { cols: "6" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(VSalesPointsSelect), {
                    modelValue: searchParams.value.salesPointId,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchParams.value.salesPointId) = $event)),
                    "sales-points-service": _ctx.salesPointsService,
                    "additional-filter-data": { municipalEntityId: searchParams.value.municipalEntityId },
                    density: "comfortable"
                  }, null, 8, ["modelValue", "sales-points-service", "additional-filter-data"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "3" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(VDateFieldV2), {
                    modelValue: searchParams.value.dateFrom,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchParams.value.dateFrom) = $event)),
                    label: "Дата с",
                    density: "comfortable"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { cols: "3" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(VDateFieldV2), {
                    modelValue: searchParams.value.dateTo,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((searchParams.value.dateTo) = $event)),
                    label: "Дата по",
                    density: "comfortable"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              (!_ctx.readonlyMe)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_col, { cols: "auto" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          variant: "text",
                          icon: "mdi-magnify",
                          onClick: update,
                          loading: _ctx.loading
                        }, null, 8, ["loading"]),
                        _createVNode(_component_v_btn, {
                          variant: "text",
                          icon: "mdi-restore",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (update($event, true))),
                          disabled: _ctx.loading
                        }, null, 8, ["disabled"])
                      ]),
                      _: 1
                    })
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_ctx.readonlyMe)
        ? (_openBlock(), _createBlock(_component_v_col, {
            key: 0,
            cols: "auto"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                variant: "text",
                icon: "mdi-magnify",
                onClick: update,
                loading: _ctx.loading
              }, null, 8, ["loading"]),
              _createVNode(_component_v_btn, {
                variant: "text",
                icon: "mdi-restore",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (update($event, true))),
                disabled: _ctx.loading
              }, null, 8, ["disabled"])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})